export function validateCnt(job_cnts) {
  if (!job_cnts) return "enter number";
  return "";
}
